import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Tooltip } from 'libs.nucleus';
export const ButtonWithTooltip = ({ tooltip, enableTooltip, tooltipPlacement = 'top', ...rest }) => {
    return enableTooltip ? (_jsx(Tooltip, { as: 'div', title: tooltip, placement: tooltipPlacement, children: _jsx(Button, { ...rest }) })) : (_jsx(Button, { ...rest }));
};
